<template>
  <div class="container">
    <div class="iframe-block" v-if="showModal">
      <iframe
        name="game"
        style="background: transparent"
        allowtransparency="true"
        src="https://red-envelope.mockuai.com"
        frameborder="0"
      ></iframe>
    </div>

    <div class="redpack" v-if="hasNextRedpack && show_fix !=2">
      <p>
        距离下场红包雨还剩:
        <span class="time-box">
          <span class="timer" v-if="show.day!='00'">{{ show.day }}</span>
          <span class="unit" v-if="show.day!='00'">天</span> 
          <span class="timer">{{ show.hour }}</span>
          <span class="unit">时</span> 
          <span class="timer">{{ show.min }}</span>
          <span class="unit">分</span> 
          <span class="timer">{{ show.sec }}</span>
          <span class="unit">秒</span>
        </span>
      </p>
      <img :src="bg" alt="" />
    </div>

    <div class="redpack-fix" v-if="hasNextRedpack && show_fix ==2">
      <img :src="bg" alt="">
    </div>
  </div>
</template>

<script>
import { Bridge } from '@mk/bridge'
import utils from '@/js/util'
export default {
  props: [
    'ids',
    'bg',
    'show_fix',
  ],
  data() {
    return {
      bridge: null,
      showGame: false,
      timer: null,
      times: 0,
      currentRedpack: null,
      nextRedpack: null,
      hasNextRedpack: true,
      show: {
        day: '00',
        hour: '00',
        min: '00',
        sec: '00',
      },
      userInfo: {},
    }
  },
  watch: {
    currentRedpack(val) {
      this.showGame = !!val
      this.hideBar(!!val)
    },
  },
  computed: {
    showModal() {
      return this.showGame
    },
  },

  created() {
    this.bridge = new Bridge();
    this.getUserInfo();
    this.getRedList();

    this.bridge.ready((apis, _bridge, env) => {
      _bridge.register('changeNativeLifeCycle', (msg) => {
        if (msg.status === 'leaveBackstage') {
          if (this.timer) {
            clearInterval(this.timer)
          }
          this.getRedList()
        }
      })
    })

    window.addEventListener('message', (message) => {
      if (message.origin !== location.origin) {
        // 开始游戏按钮
        if (message.data.stage === 'go') {
          window.TDAPP.onEvent('游戏开始按钮点击')
        }
        if (message.data.stage === 'gameover') {
          // 根据游戏端isClick判断是否点击过掉落的红包
          // 如果有就发起请求添加红包，如果没有则就返回个日期

          // 1.抢了红包，显示红包的日期，前端显示当天 —— 当天 + 90天
          // 2.抢了红包，显示已被抢完，则显示下一场日期
          // 3.没抢到红包，则显示下一场日期

          // 传递格式化时间
          if (this.nextRedpack) {
            game.window.postMessage(
              {
                type: 'date',
                value: utils.dateFormat(
                  this.nextRedpack.start_time.replace(/-/g, '/'),
                  'M月d日HH:mm'
                ),
              },
              '*'
            )
          }
          // 如果抢到了红包，传递具体信息
          if (message.data.isClick) {
            this.getCoin()
              .then((data) => {
                const grabbed_time = data.grabbed_time.replace(/-/g, '/')
                const startTime = utils.dateFormat(grabbed_time, 'yyyy.MM.dd')
                const _end_time = new Date(grabbed_time)
                // 自定义为加90天
                const endTime = utils.dateFormat(
                  new Date(_end_time.setDate(_end_time.getDate() + 90)),
                  'yyyy.MM.dd'
                )
                const _data = {
                  coin: data.amount,
                  date: `${startTime}-${endTime}`,
                }
                game.window.postMessage({ type: 'success', value: _data }, '*')
              })
              .catch((err) => {
                game.window.postMessage({ type: 'error', value: err }, '*')
              })
          }
        }
        // 红色叉叉
        if (message.data.stage === 'close-icon') {
          this.showGame = false
          this.hideBar(false)
          window.TDAPP.onEvent('点击关闭按钮，游戏未开始')
        }
        // 立即使用按钮
        if (message.data.stage === 'used') {
          this.showGame = false
          this.hideBar(false)
          this.getRedList()
          window.TDAPP.onEvent('点击立即使用按钮')
        }
        // 立即关闭按钮
        if (message.data.stage === 'close-btn') {
          this.showGame = false
          this.hideBar(false)
          this.getRedList()
          window.TDAPP.onEvent('点击关闭按钮，游戏已结束')
        }
      }
    })
  },
  methods: {
    getDiscountList() {
      lib.api.get({
        api: 'ec/b/operation/activity/supplier/item/recent/discount',
        data: {
          count: 3,
        },
        success: (res) => {
          this.discounts = res.data.list
        },
        error: (err) => {},
      })
    },
    getRedList() {
      lib.api.get({
        api: 'ec/b/market/new-red-envelope/recent/list',
        data: {
          red_envelop_id_list: this.ids,
        },
        success: (res) => {
          let nowTime = res.time || new Date().getTime();
          // 如果当前有符合条件的红包可以领取, 否则就是红包活动结束，运营会下架活动，不需要前端操作
          if (res.data && res.data.length) {
            // 取出第一个作为参照物，如果当前时间小于第一个，则证明当前场次的红包被抢完了
            const curr = res.data[0]
            // 下一个不能取[1]，因为有两个同时开始，第三个还未开始的情况，需要取下一个倒计时不为负数情况
            const next =
              res.data.find((item) => item.count_down_mills > 0) || null

            // 如果当前时间小于第一个的开始时间，则证明当前场次的红包被抢完了，直接读取第一个的倒计时
            if (
                nowTime <
              new Date(curr.start_time.replace(/-/g, '/')).getTime()
            ) {
              this.currentRedpack = null
              // 时间结束，重新请求
              this.countdown(curr.count_down_mills, () => {
                this.getRedList()
              })
              return
            }

            // 如果时间大于第一个开始时间，则证明当前还有红包
            if (
                nowTime >=
                new Date(curr.start_time.replace(/-/g, '/')).getTime() &&
                nowTime < new Date(curr.end_time.replace(/-/g, '/')).getTime()
            ) {
              this.currentRedpack = curr
              if (next) {
                this.nextRedpack = next || null
                this.countdown(next.count_down_mills, () => {
                  this.getRedList()
                })
              } else {
                this.hasNextRedpack = false
              }
            }
          } else {
            this.hasNextRedpack = false;
            this.$emit('checkPack',false);
          }
        },
        error: (err) => {},
      })
    },
    getCoin() {
      return new Promise((resolve, reject) => {
        lib.api.post({
          api: 'ec/b/market/new-red-envelope/recent/grab',
          data: {
            nickname: this.userInfo.name,
            head_url: this.userInfo.img_url,
            red_envelope_core_id: this.currentRedpack.red_envelope_id,
          },
          success: (res) => {
            resolve(res.data)
          },
          error: (err) => {
            reject(err)
          },
        })
      })
    },
    countdown(times, callback = () => {}) {
      if (this.timer) {
        clearInterval(this.timer)
      }

      let _times = times || 0
      this.timer = setInterval(() => {
        _times -= 1000
        this.show = utils.countdown(_times, true)
        if (_times <= 0) {
          _times = 0
          callback()
          clearInterval(this.timer)
          return
        }
      }, 1000)
    },
    hideBar(status) {
      this.bridge.ready((apis, bridge, env) => {
        if (env === 'pk') {
          bridge.callHandler(
            'navigationBarConfig',
            { hiddenNavigationBar: status },
            (resp) => {
              // 保存成功回调
            }
          )
        }
      })
    },
    getUserInfo() {
      lib.api.get({
        api: 'ec/c/user/info/get',
        data: {},
        success: (res) => {
          this.userInfo.name = (res.data.user_extra_info || {}).nick_name || res.data.name;
          this.userInfo.img_url = (res.data.user_extra_info || {}).head_img_url || res.data.img_url;
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.iframe-block {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10000;
  top:0;
}

iframe {
  position: absolute;
  z-index: -1;
  width: 100vw;
  height: 100vh;
  &.show {
    z-index: 10;
  }
}

.redpack {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    position: absolute;
    top: 12px;
    text-align: center;
    z-index: 1;
    color: #fff;
    font-weight: bold;
    font-size: 14px;
    font-family: PingFang SC;
    display: flex;
    align-items: center;
    .time-box {
      display: flex;
      align-items: center;
      margin-left: 10px;
      .unit {
        padding: 0 2px;
      }
      .timer {
        display: inline-block;
        width: 23px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        background: #f9dcbc;
        border-radius: 3px;
        color: #FF531E;
        font-weight: bold;
      }
    }
  }
  img {
    width: 100%;
    height: 156px;
  }
}
.redpack-fix{
  position: fixed;
  bottom: 46px;
  right: 0;
  z-index: 9999;
  img{
    width: 80px;
    display: block;
  }
}
</style>
